<template>
    <div class="w-full max-w-screen-xl mx-auto px-0 sm:px-8">
        <slider
            :options="sliderOptions"
            :items="series"
            nav-class="hidden sm:block"
        >
            <template v-slot="{ item: serie }">
                <div class="flex flex-col">
                    <router-link
                        :to="{ name: 'serie', params: { id: serie.id } }"
                        :alt="serie.personaje_ppal"
                    >
                        <app-image
                            width="100"
                            height="100"
                            :url="serie.round_icon"
                            class="w-10/12 mx-auto mb-2 rounded-full border-solid border-white border-4"
                            :alt="serie.personaje_ppal"
                            placeholder="1:1"
                            lazy
                        >
                        </app-image>
                    </router-link>

                    <p
                        class="font-primary text-base text-white text-center"
                        :class="{
                            'text-blue-dark': dark,
                            'text-white': !dark
                        }"
                    >
                        {{ serie.personaje_ppal }}
                    </p>
                </div>
            </template>
        </slider>
    </div>
</template>

<script>
import Slider from "./Slider";

export default {
    name: "characters-slider",

    components: { Slider },

    props: {
        series: {
            type: Array,
            required: true,
            default: () => []
        },
        dark: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            sliderOptions: {
                touchReleaseOnEdges: true,
                slidesPerView: 4,
                breakpoints: {
                    576: {
                        slidesPerView: 5
                    },
                    768: {
                        slidesPerView: 6
                    },
                    992: {
                        slidesPerView: 7
                    },
                    1200: {
                        slidesPerView: 9
                    }
                }
            }
        };
    }
};
</script>
<style scoped>
:focus {
    outline: none !important;
}
</style>
